window.Theme = window.Theme || {};

Theme.Product = (() => {
  let productSlider = null;
  let productThumbSlider = null;
  let currentVariant = null;

  const getMousePos = (e) => {
    var pos = e.currentTarget.getBoundingClientRect();
    return {
      x: e.clientX - pos.left,
      y: e.clientY - pos.top,
    };
  };

  function pauseMedia(container) {
    container.querySelectorAll('.yv-youtube-video').forEach(video =>
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    );
    container.querySelectorAll('.yv-vimeo-video').forEach(video =>
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    );
    container.querySelectorAll('video').forEach(video => video.pause());
  }

  function initProductSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled') && productSlider) {
        productSlider.destroy();
        productSlider = null;
      }
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider?.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider?.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productSlider = new Flickity(sliderMain, options);
        setTimeout(() => productSlider?.resize(), 300);
      }
    }

    if (productSlider) {
      productSlider.on('change', function () {
        pauseMedia(productSlider.element);
      });
    }
  }

  function initProductThumbSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-thumb-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-thumb-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled') && productThumbSlider) {
        productThumbSlider.destroy();
        productThumbSlider = null;
      }
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider?.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider?.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider = new Flickity(sliderMain, options);
        setTimeout(() => productThumbSlider?.resize(), 300);
      }
    }

    if (productThumbSlider) {
      productThumbSlider.on('change', function () {
        pauseMedia(productThumbSlider.element);
      });
    }
  }

  // ────────────────────────────────────────────────────────────────
  // Variant-based media filtering
  // ────────────────────────────────────────────────────────────────
  function updateVariantMedia(variant) {
    if (!variant) return;
    currentVariant = variant;

    // Assuming color is the FIRST option (index 0)
    // Change to variant.options[1] etc. if color is not the first dropdown
    const colorValue = variant.options[0]?.toLowerCase().trim() || '';

    if (!colorValue) return;

    const mainContainer = document.getElementById('yv-product-gallery-slider');
    if (!mainContainer) return;

    const mainItems = mainContainer.querySelectorAll('.gallery-main-item');
    const thumbItems = mainContainer.querySelectorAll('.gallery-thumbs-item');

    let visibleCount = 0;
    let firstVisibleIndex = -1;

    // Filter main gallery items
    mainItems.forEach((item, index) => {
      const img = item.querySelector('img, model-viewer');
      if (!img) {
        item.style.display = 'none';
        return;
      }

      const alt = (img.alt || img.getAttribute('aria-label') || '').toLowerCase().trim();
      const matches = alt.includes(colorValue) || alt === colorValue;

      if (matches) {
        item.style.display = '';
        visibleCount++;
        if (firstVisibleIndex === -1) firstVisibleIndex = index;
      } else {
        item.style.display = 'none';
      }
    });

    // Filter thumbnails
    thumbItems.forEach((thumb) => {
      const img = thumb.querySelector('img');
      if (!img) {
        thumb.style.display = 'none';
        return;
      }

      const alt = (img.alt || '').toLowerCase().trim();
      const matches = alt.includes(colorValue) || alt === colorValue;
      thumb.style.display = matches ? '' : 'none';
    });

    // Refresh Flickity sliders and jump to first visible slide
    if (productSlider && visibleCount > 0) {
      productSlider.resize();
      productSlider.reposition();
      if (firstVisibleIndex >= 0) {
        productSlider.select(firstVisibleIndex, false, true); // no animation
      }
    } else if (productThumbSlider) {
      productThumbSlider.resize();
      productThumbSlider.reposition();
    }

    // Fallback: show everything if no images match the variant
    if (visibleCount === 0) {
      mainItems.forEach(item => item.style.display = '');
      thumbItems.forEach(thumb => thumb.style.display = '');
      if (productSlider) productSlider?.select(0, false, true);
    }
  }

  // Try to detect variant change in multiple common ways
  function initVariantChangeListener() {
    // 1. Most common: variant selector change
    document.querySelectorAll('select[name^="options"], input[type="radio"][name^="options"], input[type="checkbox"][name^="options"]').forEach(el => {
      el.addEventListener('change', () => {
        setTimeout(() => {
          const variant = getCurrentVariant();
          if (variant) updateVariantMedia(variant);
        }, 50);
      });
    });

    // 2. Custom event (some themes use this)
    document.addEventListener('variant:changed', (e) => {
      if (e.detail?.variant) {
        updateVariantMedia(e.detail.variant);
      }
    });

    document.addEventListener('variant:change', (e) => {
      if (e.detail?.variant) {
        updateVariantMedia(e.detail.variant);
      }
    });

    // 3. Shopify common global object
    const tryGlobalVariant = () => {
      if (window.Shopify?.Product?.currentVariant) {
        updateVariantMedia(window.Shopify.Product.currentVariant);
      } else if (window.currentVariant) {
        updateVariantMedia(window.currentVariant);
      }
    };

    // Poll once on load + after any change
    setTimeout(tryGlobalVariant, 800);
    document.addEventListener('change', tryGlobalVariant, { capture: true });
  }

  // Helper: try to find current variant from common locations
  function getCurrentVariant() {
    if (window.Shopify?.Product?.currentVariant) return window.Shopify.Product.currentVariant;
    if (window.currentVariant) return window.currentVariant;

    // Last resort: read from selected inputs
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    const selectedOptions = [];
    form.querySelectorAll('select[name^="options"], input[name^="options"]:checked').forEach(el => {
      selectedOptions.push(el.value.trim());
    });

    // You would need product JSON here to match variant — skip if not available
    return null;
  }

  // ────────────────────────────────────────────────────────────────
  // Your original functions (slightly cleaned up)
  // ────────────────────────────────────────────────────────────────
  function findVisibleItems() {
    const mainSliderParent = document.getElementById('yv-product-gallery-slider');
    if (mainSliderParent) {
      const elements = mainSliderParent.getElementsByClassName('gallery-main-item');
      const thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');

      const onScroll = () => {
        Array.from(elements).forEach(item => {
          if (isOnScreen(item)) {
            const relatedThumb = mainSliderParent.querySelector(`.gallery-thumbs-item[data-image="${item.id}"]`);
            if (relatedThumb) {
              Array.from(thumbs).forEach(t => t.classList.remove('active'));
              relatedThumb.classList.add('active');
            }
          }
        });
      };

      window.addEventListener('scroll', onScroll);
      onScroll(); // initial call
    }

    // ... your tabs scroll logic remains unchanged ...
    const mainTabsContent = document.getElementById('yvProductFeatureListwrapper');
    if (mainTabsContent) {
      const contentTabs = document.getElementsByClassName('yv-product-feature');
      const onScroll = () => {
        Array.from(contentTabs).forEach(item => {
          if (isOnScreen(item)) {
            const headTabs = document.getElementsByClassName('feature-link');
            Array.from(headTabs).forEach(head => head.parentNode.classList.remove('active'));
            const relatedHead = document.querySelector(`.feature-link[href="#${item.id}"]`);
            if (relatedHead) relatedHead.parentNode.classList.add('active');
          }
        });
      };
      window.addEventListener('scroll', onScroll);
      onScroll();
    }
  }

  function sizeChart() {
    const sizeChartInit = document.querySelectorAll('.sizeChart-label');
    const sizeChartModel = document.getElementById('sizeChartModel');
    if (!sizeChartInit.length || !sizeChartModel) return;

    const sizeChartClose = sizeChartModel.querySelector('#sizeChartClose');

    sizeChartInit.forEach(label => {
      label.addEventListener("click", e => {
        e.preventDefault();
        document.body.classList.add('sizeChartOpen');
        sizeChartClose?.focus();
      });
    });

    sizeChartClose?.addEventListener("click", () => {
      document.body.classList.remove('sizeChartOpen');
    });
  }

  function initStickyAddToCart() {
    const mainProductForm = document.querySelector('.main-product-form');
    const stickyBar = document.getElementById('yvProductStickyBar');

    if (!mainProductForm || !stickyBar) return;

    const onScroll = () => {
      if (isOnScreen(mainProductForm, true) || window.scrollY < mainProductForm.offsetTop) {
        stickyBar.classList.remove('show');
      } else {
        stickyBar.classList.add('show');
      }
    };

    window.addEventListener('scroll', onScroll);
    onScroll(); // initial
  }

  function productZoomInit() {
    $('.yv-product-zoom').off('mouseenter mousemove mouseleave'); // prevent duplicates

    $('.yv-product-zoom').on('mouseenter', function (e) {
      $('.yv-product-zoom').removeClass('show');
      if ($(window).width() > 1021) {
        $(this).addClass('show');
      }
    });

    $('.yv-product-zoom').on('mousemove', function (e) {
      if ($(window).width() <= 1021) return;
      const t = getMousePos(e);
      this.querySelector('.gallery-cursor').style.translate = `${t.x}px ${t.y}px`;
    });

    $('.yv-product-zoom').on('mouseleave', function () {
      $('.yv-product-zoom').removeClass('show');
    });
  }

  function load3DModel() {
    if (!window.Shopify) return;

    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: () => {
          if (!window.ShopifyXR || typeof window.ShopifyXR.addModels !== 'function') {
            document.addEventListener('shopify_xr_initialized', load3DModel);
            return;
          }
          document.querySelectorAll('[id^="product3DModel-"]').forEach(model => {
            window.ShopifyXR.addModels(JSON.parse(model.textContent));
          });
          window.ShopifyXR.setupXRElements();
        }
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: () => {
          document.querySelectorAll('.yv-product-model-item').forEach(modelEl => {
            const modelViewer = modelEl.querySelector('model-viewer');
            if (!modelViewer) return;

            modelEl.modelViewerUI = new Shopify.ModelViewerUI(modelViewer);

            modelViewer.addEventListener('shopify_model_viewer_ui_toggle_play', () => {
              modelEl.querySelectorAll('.close-product-model').forEach(el => el.classList.remove('hidden'));
              if (productSlider) {
                productSlider.options.draggable = false;
                productSlider.updateDraggable?.();
              }
            });

            modelViewer.addEventListener('shopify_model_viewer_ui_toggle_pause', () => {
              modelEl.querySelectorAll('.close-product-model').forEach(el => el.classList.add('hidden'));
              if (productSlider) {
                productSlider.options.draggable = true;
                productSlider.updateDraggable?.();
              }
            });

            modelEl.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', () => modelEl.modelViewerUI.pause());
            });
          });
        }
      }
    ]);
  }

  function onReadyEvent() {
    // Your original onReadyEvent logic (thumbnails sticky, click handlers, etc.)
    setTimeout(() => {
      const thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
      if (!thumbnails) return;

      let lastKnownY = window.scrollY;
      let currentTop = 0;
      const initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top) || 0;

      const onScroll = () => {
        const bounds = thumbnails.getBoundingClientRect();
        const maxTop = bounds.top + window.scrollY - thumbnails.offsetTop + initialTopOffset;
        const minTop = thumbnails.clientHeight - window.innerHeight;

        if (window.scrollY < lastKnownY) {
          currentTop -= lastKnownY - window.scrollY;
        } else {
          currentTop += window.scrollY - lastKnownY;
        }

        currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset);
        lastKnownY = window.scrollY;

        thumbnails.style.top = `${currentTop}px`;
      };

      window.addEventListener('scroll', onScroll);
    }, 1000);

    // Your jQuery handlers
    jQuery('body').off('click', '.pdp-view-close').on('click', '.pdp-view-close', function (e) {
      e.preventDefault();
      jQuery('#yvProductStickyBar').remove();
    });

    jQuery('body').off('click', '.feature-link').on('click', '.feature-link', function (e) {
      e.preventDefault();
      const destination = jQuery(this).attr('href');
      const top = jQuery('.shopify-section-main-header').height() + 90;
      const target = jQuery(destination);
      if (target.length) {
        jQuery('html,body').animate({ scrollTop: target.offset().top - top });
      }
    });

    jQuery('body').off('change', '.sticky-bar-product-options').on('change', '.sticky-bar-product-options', function () {
      const section = jQuery(this).closest('.shopify-section');
      const option = jQuery(this).attr('data-name');
      const value = jQuery(this).val();
      const mainOption = section.find(`.productOption[name="${option}"]`);

      if (mainOption.is(':radio')) {
        section.find(`.productOption[name="${option}"][value="${CSS.escape(value)}"]`)
          .prop('checked', true)
          .trigger('click');
      } else {
        mainOption.val(value);
        const sectionId = document.querySelector('#' + section.attr('id'));
        if (sectionId) {
          const optionSelector = sectionId.querySelector(`.productOption[name="${option}"]`);
          if (optionSelector) {
            optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    // Fancybox (if used)
    if (typeof fancySelector !== 'undefined' && window.Fancybox) {
      Fancybox.bind(fancySelector, {
        touch: false,
        thumbs: { autoStart: true },
        on: {
          load: () => pauseMedia(document),
          done: () => pauseMedia(document)
        },
        Toolbar: { display: ["close"] }
      });
    }
  }

  function onLoad(section = document) {
    initProductSlider(section);
    initProductThumbSlider(section);
    findVisibleItems();
    productZoomInit();
    sizeChart();
    initStickyAddToCart();
    load3DModel();
    onReadyEvent();
    initVariantChangeListener();   // ← added here
  }

  // Public API
  return {
    initProductSlider,
    initProductThumbSlider,
    updateVariantMedia   // useful for debugging or manual calls
  };
})();

// Global resize handler
if (document.querySelector('[data-flickity-product-slider]') || document.querySelector('[data-flickity-product-thumb-slider]')) {
  window.addEventListener('resize', () => {
    Theme.Product.initProductSlider();
    Theme.Product.initProductThumbSlider();
    Theme.Product.findVisibleItems?.();
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  Theme.Product.onLoad?.(document);
});